//Mixin des comportement mimic du nouveau mode fiche (iris)

export const ednMimicMix = {
  data(){
    return{
      slotName: 'append'
    }
  },
  computed: {
    getAppendedIcon() {
      if (this.getIrisRdonlyMode) return 'mdi-lock';
      else if (this.fieldIcon) return this.fieldIcon;
      else if ((this.$attrs.irisMimic === '' || this.$attrs.irisMimic) && this.content && this.content.length > 0)
        return 'mdi-pencil'
    },
    getIrisRdonlyMode() {
      if (this.$attrs.rdonly === '' || this.$attrs.rdonly) {
        return this.$attrs.rdonly === '' || this.$attrs.rdonly
      }
    },
    getIrisMode() {
      let irisMimic = this.$attrs.irisMimic || this.$attrs["iris-mimic"]
      if (irisMimic || this.irisMimic) return irisMimic === '' || irisMimic || this.irisMimic
    },
    getIrisCssClass() {
      return this.getIrisMode ? 'iris-mimic' : this.getIrisRdonlyMode ? 'iris-rdonly' : ''
    },
  },
  methods: {
    focusOnInput() {
      if (this.$refs.input) this.$refs.input.focus()
    },
  },
  watch: {
    /**
     * Récupère le nom du slot et place le tooltip
     * différemment si on a le cadenas ou pas
     */
    getAppendedIcon (val) {
      this.slotName = val ? 'append-outer' : 'append';
    },
  }
}
